import { render } from "./macro_page.vue?vue&type=template&id=ee8b58c8"
import script from "./macro_page.vue?vue&type=script&lang=js"
export * from "./macro_page.vue?vue&type=script&lang=js"

import "./macro_page.vue?vue&type=style&index=0&id=ee8b58c8&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__